import moment from 'moment';
import { companyContractCodes } from '../environment';
export class Event {
  allowedParticipantsTypes = [];
  constructor(id, title, code, startDate, endDate, challengeTemplate, allowedContractCodes, _allowedParticipantsTypes, allowedSubGroupType, polygon, numberOfParticipants, sumOfProgressValues, isPublic, dedicatedWebsiteUrl, sponsor, subtitle, primaryColor, secondaryColor, textPrimaryColor, textSecondaryColor, communicationKit, defaultParticipationGroup, icon, enableIndividualLeaderboard, allowCompanySiteFilter, allowGeographicFilter, targetLevels, h3GameId = null) {
    this.id = id;
    this.title = title;
    this.code = code;
    this.startDate = startDate;
    this.endDate = endDate;
    this.challengeTemplate = challengeTemplate;
    this.allowedContractCodes = allowedContractCodes;
    this._allowedParticipantsTypes = _allowedParticipantsTypes;
    this.allowedSubGroupType = allowedSubGroupType;
    this.polygon = polygon;
    this.numberOfParticipants = numberOfParticipants;
    this.sumOfProgressValues = sumOfProgressValues;
    this.isPublic = isPublic;
    this.dedicatedWebsiteUrl = dedicatedWebsiteUrl;
    this.sponsor = sponsor;
    this.subtitle = subtitle;
    this.primaryColor = primaryColor;
    this.secondaryColor = secondaryColor;
    this.textPrimaryColor = textPrimaryColor;
    this.textSecondaryColor = textSecondaryColor;
    this.communicationKit = communicationKit;
    this.defaultParticipationGroup = defaultParticipationGroup;
    this.icon = icon;
    this.enableIndividualLeaderboard = enableIndividualLeaderboard;
    this.allowCompanySiteFilter = allowCompanySiteFilter;
    this.allowGeographicFilter = allowGeographicFilter;
    this.targetLevels = targetLevels;
    this.h3GameId = h3GameId;
    const now = moment();
    if (endDate.isBefore(now)) this.period = 'past';else if (startDate.isAfter(now)) this.period = 'future';else this.period = 'current';
    if (_allowedParticipantsTypes.includes('company') || allowedContractCodes.length > 0 && allowedContractCodes.find(key => companyContractCodes.includes(key))) {
      this.allowedParticipantsTypes.push('companies');
    }
    if (_allowedParticipantsTypes.includes('city') || allowedContractCodes.length > 0 && allowedContractCodes.find(key => !companyContractCodes.includes(key))) {
      this.allowedParticipantsTypes.push('territories');
    }
  }
  get isOnlyForCompanies() {
    return this.allowedParticipantsTypes.length === 1 && this.allowedParticipantsTypes.includes('companies');
  }
  get isForCompanies() {
    return this.allowedParticipantsTypes.length > 0 && this.allowedParticipantsTypes.includes('companies');
  }
  get isOnlyForTerritories() {
    return this.allowedParticipantsTypes.length === 1 && this.allowedParticipantsTypes.includes('territories');
  }
  get isForTerritories() {
    return this.allowedParticipantsTypes.length > 0 && this.allowedParticipantsTypes.includes('territories');
  }
}